document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname === "/collections/all") {
    var element = document.querySelector(".collection-title");
    if (element) {
      element.style.display = "none";
    }
  }

  // Reusable function to hide form section based on lang and data-forms-id
  function hideFormSectionByLang(lang, formsId) {
    if (document.documentElement.lang === lang) {
      var formsElement = document.querySelector('[data-forms-id="' + formsId + '"]');
      if (formsElement) {
        var section = formsElement.closest('.shopify-section--apps');
        if (section) {
          section.style.display = 'none';
        }
      }
    }
  }

  hideFormSectionByLang('de', 'forms-root-424505');
  hideFormSectionByLang('en', 'forms-root-424512');
});